import { render } from "./ForgotPWD.vue?vue&type=template&id=27da0c2f&ts=true"
import script from "./ForgotPWD.vue?vue&type=script&lang=ts"
export * from "./ForgotPWD.vue?vue&type=script&lang=ts"

import "./ForgotPWD.vue?vue&type=style&index=0&id=27da0c2f&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__